<script setup lang="ts">
import { computed } from "vue";

import SelectNamedValue from "@/components/ui/SelectNamedValue/SelectNamedValue.vue";
import { useSearchMenuStore } from "@/store/search/searchMenu";

import ArtItemTooltip from "../tooltips/ArtItemTooltip.vue";
import SearchDropdown from "./SearchDropdown.vue";

const store = useSearchMenuStore();

const selection = computed({
  get: () => store.selectedArts,
  set: (values: Array<{ id: string }>) =>
    (store.selectedArtIds = new Set(values.map((val) => val.id))),
});
</script>

<template>
  <SearchDropdown
    name="art"
    icon="general/art"
    label-key="general.arts"
    :selected="selection.length > 0"
  >
    <template #tooltip>
      <ArtItemTooltip :arts="selection" />
    </template>
    <SelectNamedValue v-model="selection" :values="store.allArts" :header="$t('general.arts')" />
  </SearchDropdown>
</template>
